console.log('components');

import './components/modal';
import './components/slider';
import './components/burger';
import './components/rating';
import './components/calculator';
import './components/show-more';
import './components/review';
